const IS_DEVELOPMENT = process.env.DOTENV === 'development' || process.env.DOTENV === 'development_prod';
const IS_PRODUCTION = process.env.DOTENV === 'production';

export default {
    app: {
        name: 'Account',
        shortName: 'TIDAL',
        tagline: 'High Fidelity Music Streaming',
        description: 'TIDAL is the first global music streaming service with high fidelity sound, hi-def video quality, along with expertly curated playlists and original content — making it a trusted source for music and culture.',
    },
    APP_DIRECTORY: 'app/',
    /** @type {'prod' | 'stage' | 'dev'} */
    // @ts-ignore
    ENV: IS_PRODUCTION ? 'prod' : IS_DEVELOPMENT ? 'dev' : 'stage',
    ENV_DIRECTORY: 'environment/',
    DEFAULT_LOCALE: 'en',
    IS_DEVELOPMENT,
    IS_PRODUCTION,
    LOG_AXIOS: IS_DEVELOPMENT,
    X_TIDAL_USER_ID: 'x-tidal-user-id',
};
